import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initCollectionSearchFilters from '../sections/collection/initCollectionSearchFilters';
import initCustomSortBy from '../sections/collection/initCustomSortBy';

// Collection Banner - Read More / Read Less
const SELECTOR_COLLAPSED = '[data-collapsed]';

function checkTruncation() {
  document.querySelectorAll(SELECTOR_COLLAPSED).forEach(function(collapsed) {
    const span = collapsed.querySelector('.truncate');
    const btn = collapsed.querySelector('[data-read-more]');
    if (!span || !btn) return;
    btn.classList.toggle('hidden', span.scrollWidth <= span.clientWidth);
  });
}

function initReadMore() {
  if (window.__collectionBannerThinReadMoreInit) return;
  window.__collectionBannerThinReadMoreInit = true;

  window.addEventListener('resize', checkTruncation);

  document.addEventListener('click', async function(event) {
    const readMoreButton = event.target.closest('[data-read-more]');
    if (readMoreButton) {
      const wrapper = readMoreButton.closest('.text-description-wrapper');
      if (!wrapper) return;

      const collapsed = wrapper.querySelector(SELECTOR_COLLAPSED);
      const expanded = wrapper.querySelector('[data-expanded]');
      if (!collapsed || !expanded) return;

      collapsed.classList.add('hidden');
      expanded.classList.remove('hidden');
      return;
    }

    const readLessButton = event.target.closest('[data-read-less]');
    if (readLessButton) {
      const wrapper = readLessButton.closest('.text-description-wrapper');
      if (!wrapper) return;

      const collapsed = wrapper.querySelector(SELECTOR_COLLAPSED);
      const expanded = wrapper.querySelector('[data-expanded]');
      if (!collapsed || !expanded) return;

      expanded.classList.add('hidden');
      collapsed.classList.remove('hidden');
    }
  });
}

// Collection Banner - Filter Tabs
function initFilterTabs() {
  if (window.__collectionBannerThinFiltersInit) return;
  window.__collectionBannerThinFiltersInit = true;

  const normalizeValue = function(value) {
    return (value || '').trim().toLowerCase();
  };

  const setTabState = function(tab, isActive) {
    tab.classList.toggle('bg-black', isActive);
    tab.classList.toggle('text-white', isActive);
    tab.classList.toggle('border-black', isActive);

    tab.classList.toggle('text-gray-600', !isActive);
    tab.classList.toggle('border-transparent', !isActive);
    tab.classList.toggle('hover:text-black', !isActive);
    tab.classList.toggle('hover:border-gray-300', !isActive);
  };

  const activateTabsByKey = function(filterKey) {
    document.querySelectorAll('[data-collection-banner-filter-group]').forEach(function(group) {
      const tabs = Array.from(group.querySelectorAll('[data-collection-banner-filter]'));
      let activeFound = false;

      tabs.forEach(function(tab) {
        const isActive = normalizeValue(tab.dataset.filterKey) === normalizeValue(filterKey);
        setTabState(tab, isActive);
        if (isActive) activeFound = true;
      });

      if (!activeFound && tabs.length > 0) {
        const clearTab = tabs.find(function(tab) {
          return tab.dataset.filterKey === '__clear__';
        });

        if (clearTab) {
          tabs.forEach(function(tab) {
            setTabState(tab, tab === clearTab);
          });
        }
      }
    });
  };

  const updateCollectionContent = function(doc) {
    const pairs = [
      ['[data-product-grid]', '[data-product-grid]'],
      ['[data-pagination]', '[data-pagination]'],
      ['[data-filters-results-count]', '[data-filters-results-count]'],
      ['[data-active-filter-count]', '[data-active-filter-count]'],
      ['[data-active-filters]', '[data-active-filters]'],
      ['[data-filter-form]', '[data-filter-form]']
    ];

    pairs.forEach(function(pair) {
      const currentNode = document.querySelector(pair[0]);
      const nextNode = doc.querySelector(pair[1]);

      if (currentNode && nextNode) {
        currentNode.innerHTML = nextNode.innerHTML;
      }
    });

    if (typeof window.ReloadSmartWishlist === 'function') {
      window.ReloadSmartWishlist();
    }
  };

  const fetchAndRender = async function(targetUrl) {
    const requestUrl = new URL(targetUrl, window.location.origin);
    let sectionId = '';

    const filterDrawer = document.querySelector('[data-filter-drawer]');
    if (filterDrawer && filterDrawer.dataset.sectionId) {
      sectionId = filterDrawer.dataset.sectionId;
    }

    if (sectionId) {
      requestUrl.searchParams.set('section_id', sectionId);
    }

    const response = await fetch(requestUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!response.ok) throw new Error('Failed to fetch filtered collection');

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    updateCollectionContent(doc);
  };

  document.addEventListener('click', async function(event) {
    const tab = event.target.closest('[data-collection-banner-filter]');
    if (!tab) return;

    const filterKey = tab.dataset.filterKey || '';
    event.preventDefault();

    let targetUrl = tab.getAttribute('href') || window.location.pathname;
    if (filterKey === '__clear__') {
      targetUrl = window.location.pathname;
    }

    activateTabsByKey(filterKey === '__clear__' ? '__clear__' : filterKey);

    try {
      await fetchAndRender(targetUrl);
      window.history.pushState({}, '', targetUrl);
    } catch (error) {
      window.location.href = targetUrl;
    }
  });

  const currentFilterTag = new URL(window.location.href).searchParams.get('filter.p.tag');
  activateTabsByKey(currentFilterTag || '__clear__');
}

ready(() => {
  initCollectionSearchFilters();
  initCustomSortBy();
  initReadMore();
  initFilterTabs();
});

onShopifySectionLoad(() => {
  initCollectionSearchFilters();
  initCustomSortBy();
  initReadMore();
  initFilterTabs();
});
